import 'twin.macro';
import React from 'react';
import { Separator } from '@teetsh/app/src/containers/Livrets/LivretEval/LivretEleve/Separator';
import Card from '@teetsh/app/src/components/Card';
import { useTranslation } from 'react-i18next';

export function LivretStructure({ children }: { children: React.ReactNode }) {
  return <Card tw="bg-white pb-20">{children}</Card>;
}

function Part({
  children,
  title,
  className,
}: {
  children: React.ReactNode;
  title: string;
  className?: string;
}) {
  return (
    <div tw="mb-10" className={className}>
      <Separator title={title} />
      {children}
    </div>
  );
}

function Family({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation(['carnet']);
  return (
    <Part
      title={t('carnet:livret.communicationWithFamily')}
      tw="break-inside-avoid"
    >
      {children}
    </Part>
  );
}

function Bilan({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation(['carnet']);
  return (
    <Part
      title={t('carnet:livret.bilanAcquisitionCompetence')}
      tw="break-inside-avoid"
    >
      <div tw="bg-brand-quiet mb-8 rounded-lg px-2">{children}</div>
    </Part>
  );
}

function SuiviAcquis({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation(['carnet']);
  return <Part title={t('carnet:livret.suiviAcquisScolaire')}>{children}</Part>;
}

function Header({ children }: { children: React.ReactNode }) {
  return <div tw="mb-8">{children}</div>;
}

LivretStructure.Header = Header;
LivretStructure.SuiviAcquis = SuiviAcquis;
LivretStructure.Bilan = Bilan;
LivretStructure.Family = Family;
